<template>
  <div>
    <PageTitle title="Create Waiter" :backBtn="true" :showLoading="isLoading" />

    <v-container fluid class="lighten-12 content">
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-row class="waiter">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="12">
                <v-card class="lighten-12 card-content mb-1">
                  <v-card-title> General</v-card-title>

                  <v-container fluid class="light gray lighten-12">
                    <form>
                      <v-row>
                        <v-col cols="12" sm="6" md="6" lg="6">
                          <ValidationProvider
                            v-slot="{ errors }"
                            vid="name"
                            name="Name"
                            rules="required|no_spaces_only"
                          >
                            <v-text-field
                              outlined
                              dense
                              v-model="waiter.name"
                              :error-messages="errors"
                              label="Name"
                              hide-details="auto"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" sm="6" md="12" lg="12">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Description"
                          >
                            <v-textarea
                              hide-details="auto"
                              outlined
                              dense
                              rows="2"
                              v-model="waiter.remarks"
                              :error-messages="errors"
                              label="Description"
                            ></v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </form>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-card class="lighten-12 card-content">
                  <v-card-title> Address</v-card-title>
                  <v-container>
                    <AddressComponent
                      ref="addressComponent"
                      :address="waiter.address"
                    />
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="lighten-12 card-content" height="100%">
                  <v-card-title> Contact</v-card-title>
                  <v-container fluid class="light gray lighten-12">
                    <v-row>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="{
                            regex: /^(0\d{9}|\+94\d{9})$/,
                          }"
                        >
                          <v-text-field
                            hide-details="auto"
                            dense
                            outlined
                            maxlength="12"
                            v-model="waiter.contact.telephone"
                            :error-messages="errors"
                            label="Telephone"
                            required
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Phone"
                          :rules="{
                            required: true,
                            regex: /^(0\d{9}|\+94\d{9})$/,
                          }"
                        >
                          <v-text-field
                            dense
                            outlined
                            v-model="waiter.contact.phone"
                            :error-messages="errors"
                            label="Phone"
                            maxlength="12"
                            required
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Email"
                          vid="email"
                          rules="email"
                        >
                          <v-text-field
                            outlined
                            dense
                            hide-details="auto"
                            v-model="waiter.contact.email"
                            :error-messages="errors"
                            label="E-mail"
                            required
                          ></v-text-field>
                          <!-- <ServerMessages dense name="email" /> -->
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </ValidationObserver>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <v-btn @click="clear" depressed small class="ml-1 text-white btn_medium"
          >clear</v-btn
        >
        <v-btn
          @click="submit"
          depressed
          small
          class="text-white btn_blue btn_medium w-100"
          >submit</v-btn
        >
      </v-card-actions>
    </v-container>
  </div>
</template>

<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import { Waiter } from "../../../models/Waiter";
import { WaiterEntityModel } from "../../../models/EntityModels/WaiterEntityModel";
import AddressComponent from "../../shared/components/Address";
import { mapGetters } from "vuex";
import FileUpload from "@/components/base/FileUpload";
import ServerMessages from "@/components/shared/ServerMessages";

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});
extend("regex", {
  ...regex,
  message: "The value is not a valid phone number",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    AddressComponent,
    FileUpload,
    ServerMessages,
    WaiterEntityModel,
    mapGetters,
  },

  data: () => ({
    checkbox: null,
    waiter: new Waiter(),
    errors: [],
    messages: [],
    selectedImages: "",
    countries: [],

    ServerError: "",
  }),

  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.RegisterWaiter();
      }
    },

    clear() {
      this.$refs.observer.reset();   
  this.waiter = new Waiter();  
    },
    RegisterWaiter() {
      this.$store
        .dispatch("waiter/CreateWaiter", new Waiter().initialise(this.waiter))
        .then((res) => {
          this.succeeed = true;

          this.$router.push("/waiter");
          this.$toast.success("Waiter added  successfully");
          this.isLoading = false;
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.messages = err.data.title;
          this.isLoading = false;

          this.$toast.error("Waiter creation failed");
        });
    },

    GetCountries() {
      this.$store
        .dispatch("GetCountries")
        .then((res) => {
          this.countries = res.data;
          console.log("USERRRSSS");
        })
        .catch((err) => {
          //  this.messages = err.data.title;
          this.isLoading = false;
        });
    },
  },
  created() {
    this.GetCountries();
  },
  computed: {
    // ...mapGetters("Countryname", ["GetCountries"]),
  },
};
</script>

<style scoped>
.waiter {
  font-size: 12px !important;
}
/* .btnRightMargin {
  margin-right: 10px;
}

.container {
  color: white !important;
}
.form-blue {
  background: #d8dbe0;
  border-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.messages {
  border: transparent !important;
  margin-right: 40px;
} */
</style>
